import React from 'react';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { BsButton, BsSecondaryButton, BsDangerButton, BsSuccessButton } from "@MyLib/Bootstrap/BsUI.jsx";
import { BsPagination } from "@MyLib/Bootstrap/BsPagination.jsx";
import { BsEditableText } from "@MyLib/Bootstrap/BsEditableText.jsx";
import { BsModal, BsModalDialog, BsYesNoDialog } from "@MyLib/Bootstrap/BsModal.jsx";
import { BsCheckBoxLabel, BsSelectBoxLabel, BsInputLabel, BsTextArea } from '@MyLib/Bootstrap/BsForm';
import { useIsMobile } from "@MyLib/System/Mobile.js";

export const MyButton = ({onClick, text, disabled=false, outline=false}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsButton onClick={onClick} text={text} disabled={disabled} outline={outline} btnSize={isMobile?"btn-lg":null}/>
	);
};
export const MySecondaryButton = ({onClick, text, disabled=false, outline=false}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsSecondaryButton onClick={onClick} text={text} disabled={disabled} outline={outline} btnSize={isMobile?"btn-lg":null}/>
	);
};
export const MyDangerButton = ({onClick, text, disabled=false, outline=false}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsDangerButton onClick={onClick} text={text} disabled={disabled} outline={outline} btnSize={isMobile?"btn-lg":null} />
	);
};
export const MySuccessButton = ({onClick, text, disabled=false, outline=false}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsSuccessButton onClick={onClick} text={text} disabled={disabled} outline={outline} btnSize={isMobile?"btn-lg":null} />
	);
};

export const MyCheckBoxLabel = BsCheckBoxLabel;
export const MySelectBoxLabel = ({name, itemList, value, setValue, onChange}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsSelectBoxLabel name={name} itemList={itemList} value={value} setValue={setValue} onChange={onChange} formSize={isMobile?"form-select-lg":null} />
	);
};
export const MyInputLabel = ({name, placeholder, value, setValue}) => {
	const {isMobile} = useIsMobile();
	return (
		<BsInputLabel name={name} placeholder={placeholder} value={value} setValue={setValue} formSize={isMobile?"form-select-lg":null} />
	);
};
export const MyTextArea = BsTextArea;

export const MyEditableText = BsEditableText;

export const MyPagination = ({page}) =>
{
	const { t } = useTranslation();
	return (
		<div className="d-flex justify-content-center p-0">
			<BsPagination page={page} prev={t("Common_Previous")} next={t("Common_Next")} />
		</div>
	);
};

export const MyModal = BsModal;
export const MyModalDialog = BsModalDialog;
export const MyYesNoDialog = BsYesNoDialog;

export const MyButtonToggle = ({text, name, checked, onChange}) => {
	const onClick = (e) => {
		onChange({
			target: {
				name: name,
				checked: !checked
			}
		});
		e.target.blur();
	};

	if (checked) {
		return (<MyButton
			onClick={onClick}
			text={text}
		/>);
	}
	else {
		return (<MySecondaryButton
			onClick={onClick}
			text={text}
		/>);
	}
};

export const useCollapsiblePanel = () => {
	const [open, setOpen] = useState(false);
	return {open, setOpen};
}

export const CollapsiblePanel = ({state, text, summary, children}) => {
	const { t } = useTranslation();
	return (
		<div className='d-flex flex-column gap-1'>
			<div>
				<MyButton
					text={`${text} - ${state.open ? t("Common_Close") : t("Common_Open")}`}
					onClick={() => state.setOpen(o => !o)}
				/>
			</div>
			{!state.open && summary && (
				<div className="text-muted small">
					{summary}
				</div>
			)}
			<div className={`collapse ${state.open ? "show" : ""}`}>
				{children}
			</div>
		</div>
	);
};

export const MyPanel = ({children}) => {
	return (
		<div className="border rounded p-3">
			{children}
		</div>
	);
};

export const MyHead1 = ({children}) => {
	return (
		<div className="fw-bold mb-3">
			{children}
		</div>
	);
};

export const MyHead2 = ({children}) => {
	return (
		<div className="fw-bold mb-1">
			{children}
		</div>
	);
};

export const MyHead3 = ({children}) => {
	return (
		<div className="fw-bold">
			{children}
		</div>
	);
};

export const Hr = () => {
	return (<div className="border-top my-1" />);
}

export const Vr = () => {
	return <div className="vr" />
};